import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid } from "@mui/material";
import { Link } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import verified from "assets/images/verified.png";
import pending from "assets/images/load.png";

function ArQuestions() {
  const [topicFilter] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      subjectId: params.get("subject_id") || "",
      topicId: params.get("topic_id") || "",
      topicName: params.get("topic_name") || "",
    };
  });
  const [items, setItems] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(20);
  const [pagination, setPagination] = useState({});
  const [notification, setNotification] = useState({
    open: false,
    color: "success",
    message: "",
  });

  const showMessage = (message, color = "success") => {
    setNotification({ open: true, color, message });
    setTimeout(() => setNotification({ open: false, color, message: "" }), 2500);
  };

  const loadItems = async (page = pageNo, currentLimit = limit) => {
    if (init() !== "success") return;

    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(currentLimit),
      });
      if (topicFilter.subjectId) params.append("subject_id", topicFilter.subjectId);
      if (topicFilter.topicId) params.append("topic_id", topicFilter.topicId);

      const resp = await axios.get(
        `${Constants.getUrls.getAllArQuestions}?${params.toString()}`
      );
      setItems(resp?.data?.data?.docs || []);
      setPagination(resp?.data?.data || {});
      setPageNo(resp?.data?.data?.page || page);
      setLimit(resp?.data?.data?.limit || currentLimit);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to load AR questions.", "error");
    }
  };

  useEffect(() => {
    loadItems(1, limit);
  }, []);

  const handleDelete = async (id) => {
    try {
      const resp = await axios.delete(`${Constants.deleteUrls.deleteArQuestion}${id}`);
      showMessage(resp?.data?.message || "AR question deleted successfully.");
      loadItems(pageNo, limit);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to delete AR question.", "error");
    }
  };

  const rows = items.map((item, index) => ({
    serial: (pageNo - 1) * limit + index + 1,
    question: (
      <MDBox>
        <MDTypography variant="button" fontWeight="medium" display="block">
          {item?.question || "-"}
        </MDTypography>
        <MDTypography variant="caption" color="secondary" display="block">
          {item?.subject_id?.subject_name || "-"} • {item?.topic_id?.topic_name || "-"} •{" "}
          {item?.level_id?.level_name || "-"}
        </MDTypography>
      </MDBox>
    ),
    answer: item?.answer || "-",
    type: item?.question_type || "-",
    status: (
      <img
        src={item?.approved_status === "approved" ? verified : pending}
        height={item?.approved_status === "approved" ? "50px" : "30px"}
        alt={item?.approved_status || "pending"}
      />
    ),
    action: (
      <>
        <Link to={`/update-ar-question/${item._id}`}>
          <MDButton
            variant="outlined"
            size="small"
            color="success"
            style={{ marginRight: "8px", marginBottom: "8px" }}
          >
            Update
          </MDButton>
        </Link>
        <MDButton
          variant="outlined"
          size="small"
          color="error"
          onClick={() => handleDelete(item._id)}
        >
          Delete
        </MDButton>
      </>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              AR Questions
              {topicFilter.topicName ? ` • ${topicFilter.topicName}` : ""}
            </MDTypography>
          </MDBox>
          <Grid item sm={4} px={2} py={2} align="right">
            <Link to="/ar-levels">
              <MDButton variant="contained" size="small" color="info" style={{ marginRight: "10px" }}>
                AR Levels
              </MDButton>
            </Link>
            <Link to="/add-bulk-ar-question">
              <MDButton variant="contained" size="small" color="primary">
                Bulk Import AR Questions
              </MDButton>
            </Link>
          </Grid>
          <MDBox>
            <DataTable
              table={{
                columns: [
                  { Header: "serial", accessor: "serial", width: "6%" },
                  { Header: "Question", accessor: "question" },
                  { Header: "Answer", accessor: "answer", width: "10%" },
                  { Header: "Type", accessor: "type", width: "10%" },
                  { Header: "Status", accessor: "status", width: "10%" },
                  { Header: "Action", accessor: "action", width: "12%" },
                ],
                rows,
              }}
              entriesPerPage={{ defaultValue: limit, entries: [10, 25, 50, 100] }}
              page_no={pagination?.page}
              totalPages={pagination?.totalPages}
              hasNextPage={pagination?.hasNextPage}
              hasPrevPage={pagination?.hasPrevPage}
              isnextPage={pagination?.nextPage}
              prevPage={pagination?.prevPage}
              totalDocs={pagination?.totalDocs}
              onPageChange={(page) => loadItems(page, limit)}
              onEntriesPerPageChange={(newLimit) => loadItems(1, newLimit)}
            />
          </MDBox>
          <MDSnackbar
            color={notification.color}
            icon="notifications"
            title="AgriQuiz"
            content={notification.message}
            dateTime="Just now"
            open={notification.open}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default ArQuestions;
